import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import { GA_ID } from 'Config/api';
import reportWebVitals from './reportWebVitals';
import App from './App';

TagManager.initialize({
  gtmId: GA_ID
});

ReactGA.initialize(GA_ID);

if (process.env.REACT_APP_BUILDTIME_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://d172a2b5103c48d3859e4bad2413d482@o79711.ingest.sentry.io/5825682',
    integrations: [new Integrations.BrowserTracing()],
    environment:
      process.env.REACT_APP_BUILDTIME_ENV === 'production'
        ? 'production'
        : 'staging',
    tracesSampleRate: 1.0,
  });
}

const scriptsURL = [
  process.env.REACT_APP_MEKARI_INSIGHT_SDK_URL,
]
const injectScripts = (urls) => {
  urls.forEach((url) => {
    if (url && url.trim() !== '') {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      document.head.appendChild(script);
    }
  });
};
injectScripts(scriptsURL)

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
